export default __webpack_public_path__ + "static/media/Timesheet_Filled_Active.b82e1325.svg";